export const PROVIDER_THEMES = {
  alfa: {
    accent: "#f04438",
    surface: "rgba(240, 68, 56, 0.12)",
  },
  "mtc touch": {
    accent: "#06b6d4",
    surface: "rgba(6, 182, 212, 0.14)",
  },
  touch: {
    accent: "#06b6d4",
    surface: "rgba(6, 182, 212, 0.14)",
  },
  sodetel: {
    accent: "#4f46e5",
    surface: "rgba(79, 70, 229, 0.12)",
  },
  terranet: {
    accent: "#3b82f6",
    surface: "rgba(59, 130, 246, 0.14)",
  },
  ogero: {
    accent: "#0f766e",
    surface: "rgba(15, 118, 110, 0.12)",
  },
  simly: {
    accent: "#7c3aed",
    surface: "rgba(124, 58, 237, 0.12)",
  },
  esim: {
    accent: "#7c3aed",
    surface: "rgba(124, 58, 237, 0.12)",
  },
  default: {
    accent: "#2e628d",
    surface: "rgba(46, 98, 141, 0.12)",
  },
};

export function getProviderTheme(title) {
  const key = String(title || "").trim().toLowerCase();
  return PROVIDER_THEMES[key] || PROVIDER_THEMES.default;
}

export function getProviderInitials(title) {
  return String(title || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase() || "BP";
}

export function hasEsimWarning(title) {
  const normalizedTitle = String(title || "").toLowerCase();
  return normalizedTitle.includes("esim") || normalizedTitle.includes("simly");
}
